import React from "react";
import { useOutletContext } from "react-router-dom";
import { Space, Tag } from "antd";

const TAGS_SPACE_SIZE = 0;

type UserGroup = {
  id: string;
  name: string;
};

type OutletContext = {
  getUserGroup: (id: string) => UserGroup | undefined;
};

type Props = {
  userGroupIds: string[];
};

const UserGroupsColumn = ({ userGroupIds }: Props): JSX.Element | null => {
  const { getUserGroup } = useOutletContext<OutletContext>();

  const hasUserGroupIds = userGroupIds.length > 0;

  if (!hasUserGroupIds) {
    return null;
  }

  const getUserGroupName = (id: string): string | null => {
    const userGroup = getUserGroup(id);

    if (!userGroup) {
      return null;
    }

    return userGroup.name;
  };

  const activeUserGroupNames = userGroupIds
    .filter((id) => !!getUserGroupName(id))
    .map((id) => getUserGroupName(id));

  return (
    <Space size={TAGS_SPACE_SIZE}>
      {
        activeUserGroupNames.map((name, index) => (
          <Tag key={index}>{name}</Tag>
        ))
      }
    </Space>
  );
};

export default UserGroupsColumn;
